import { action, makeAutoObservable, observable } from 'mobx';
import { InterviewPracticeStepCode } from '@domain/constant/interviewPracticeStep';

export default class InterviewPracticeUIStore {
  @observable private _currentStep = InterviewPracticeStepCode.PERMISSION;

  // 현재 진행중인 질문 Index
  @observable currentPracticeIndex = 0;

  // 질문 개수
  @observable practiceCount = 0;

  // 다음으로 이동할 수 있는지 여부를 갖고 오는 함수, 에러 화면으로 전환 된 경우에는 다음으로의 이동이 방지됩니다.
  @observable getNextAvailable: () => boolean = () => true;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  readonly initialize = (practiceCount: number, currentPracticeIndex: number, getNextAvailable: () => boolean) => {
    this.practiceCount = practiceCount;
    this.currentPracticeIndex = currentPracticeIndex;
    this.getNextAvailable = getNextAvailable;
  };

  private getNextStep() {
    switch (this._currentStep) {
      case InterviewPracticeStepCode.PERMISSION:
        return InterviewPracticeStepCode.INTRO;
      case InterviewPracticeStepCode.INTRO:
        return InterviewPracticeStepCode.TEST_START;
      case InterviewPracticeStepCode.TEST_START:
        return InterviewPracticeStepCode.TEST_PROGRESS;
      case InterviewPracticeStepCode.TEST_PROGRESS:
        return InterviewPracticeStepCode.TEST_END;
      case InterviewPracticeStepCode.TEST_END:
        return InterviewPracticeStepCode.GUIDE_STEP1;
      case InterviewPracticeStepCode.GUIDE_STEP1:
        return InterviewPracticeStepCode.GUIDE_STEP2;
      case InterviewPracticeStepCode.GUIDE_STEP2:
        return InterviewPracticeStepCode.PRACTICE_GUIDE;
      case InterviewPracticeStepCode.PRACTICE_GUIDE:
        return InterviewPracticeStepCode.PRACTICE_THINK;
      case InterviewPracticeStepCode.PRACTICE_THINK:
        return InterviewPracticeStepCode.PRACTICE_RECORD;
      case InterviewPracticeStepCode.PRACTICE_RECORD: // 모든 질문에 답변할 때까지 무한 루프 돕니다.
        if (this.currentPracticeIndex < this.practiceCount - 1) {
          this.currentPracticeIndex++;
          return InterviewPracticeStepCode.PRACTICE_SUBMITTED_GUIDE;
        } else {
          return InterviewPracticeStepCode.FINISH_GUIDE; // 전부 답변 했다면 탈출
        }
      case InterviewPracticeStepCode.PRACTICE_SUBMITTED_GUIDE:
        return InterviewPracticeStepCode.PRACTICE_THINK;
      case InterviewPracticeStepCode.FINISH_GUIDE:
        return InterviewPracticeStepCode.FINISH_RESULT;
      default:
        return null;
    }
  }

  @action
  toNextStep() {
    if (!this.getNextAvailable()) {
      return;
    }
    const next = this.getNextStep();
    if (next) {
      this._currentStep = next;
    }
  }

  setStep(step: InterviewPracticeStepCode) {
    this._currentStep = step;
  }

  get currentStep(): InterviewPracticeStepCode {
    return this._currentStep;
  }
}
